import { TimeslotModel } from '../models/timeslot.model';
import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import mapValues from 'lodash/mapValues';
import filter from 'lodash/filter';
import size from 'lodash/size';
import range from 'lodash/range';

export function calculateNumberOfAvailableSlots(
  timeslot: TimeslotModel,
  numberOfParticipantsPerTimeSlot: number
): number {
  const totalSlots = timeslot.timeSlotIndexes.length;
  const slotsWithParticipants = mapValues(
    groupBy(timeslot.answers, 'selectedTimeSlotIndex'),
    answers => uniqBy(answers, a => a.concerningProfile?.id ?? a.id).length
  );
  const availableSlots = filter(
    range(totalSlots),
    index => (slotsWithParticipants[index] || 0) < numberOfParticipantsPerTimeSlot
  );
  return size(availableSlots);
}
